import { render, staticRenderFns } from "./EliminarCuentaView.vue?vue&type=template&id=fc0816e6&"
import script from "./EliminarCuentaView.vue?vue&type=script&lang=ts&"
export * from "./EliminarCuentaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports